import { motion } from 'framer-motion';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-robot-2-line',
      title: 'Agentes IA Interactivos 3D',
      description: 'Automatización avanzada con flujos de trabajo visuales y dashboards holográficos',
      features: [
        'Automatización n8n con nodos 3D pulsantes',
        'Sistemas Pancake.biz con datos volumétricos',
        'Respond.io multicanal con chatbots 3D',
        'Generación visual en tiempo real'
      ],
      gradient: 'from-cyan-500 to-blue-600',
      image: 'https://public.readdy.ai/ai/img_res/659fb33fe87a798073c9218bf628124c.jpg'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Desarrollo Web/Apps Futuristas 3D',
      description: 'Páginas y aplicaciones con interfaces holográficas y efectos inmersivos',
      features: [
        'Scroll parallax 3D y transiciones espaciales',
        'Interfaces holográficas con gestos táctiles',
        'Efectos de partículas reactivos',
        'Diseño responsive con profundidad'
      ],
      gradient: 'from-purple-500 to-pink-600',
      image: 'https://readdy.ai/api/search-image?query=modern%20web%20development%203D%20holographic%20interface%20purple%20pink%20gradient%20floating%20UI%20elements%20futuristic%20design%20clean%20minimal%20background&width=600&height=400&seq=service-web&orientation=landscape'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Nexo Educación Inmersiva',
      description: 'Cursos interactivos con avatares 3D y simulaciones avanzadas',
      features: [
        'Avatares 3D instructores personalizados',
        'Agentes IA para creación curricular',
        'Simulaciones de educación vial',
        'Entrenamiento de trading interactivo'
      ],
      gradient: 'from-green-500 to-teal-600',
      image: 'https://readdy.ai/api/search-image?query=immersive%20education%203D%20virtual%20classroom%20holographic%20teacher%20avatar%20green%20teal%20gradient%20interactive%20learning%20environment%20modern%20technology&width=600&height=400&seq=service-edu&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="relative py-32 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Ecosistema NEXUS
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Servicios 3D que transforman la manera en que interactúas con la tecnología
          </p>
        </motion.div>

        <div className="space-y-32">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}
            >
              <div className="flex-1">
                <div className="relative group">
                  <div className={`absolute inset-0 bg-gradient-to-r ${service.gradient} opacity-20 blur-3xl group-hover:opacity-30 transition-opacity duration-500`}></div>
                  <div className="relative rounded-3xl overflow-hidden border border-gray-800 group-hover:border-cyan-500/50 transition-all duration-500">
                    <div className="aspect-[3/2] w-full">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-700"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br ${service.gradient} mb-6`}>
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-3xl font-bold text-white mb-4">{service.title}</h3>
                <p className="text-lg text-gray-400 mb-8 leading-relaxed">{service.description}</p>
                <ul className="space-y-4">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-start">
                      <div className={`w-6 h-6 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center mt-1 mr-3 flex-shrink-0`}>
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <span className="text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
